module.exports = __webpack_public_path__ + "img/logo-old.b4f8d94f.svg";